<template>
  <div class="message-banner">
    <slot>
      <sanitize-html :dirty="message"></sanitize-html>
    </slot>
  </div>
</template>

<script>
import SanitizeHtml from "~/Components/Common/SanitizeHtml.vue";

export default {
  name: "MessageBanner",
  components: {
    SanitizeHtml
  },
  props: {
    message: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped lang="less">
@import "../../Styles/utils/colors";

.message-banner {
  border-radius: 5px;
  background-color: @color-accent-6;
  padding: 1.5rem;
  color: #fff;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.3);

  p {
    margin: 0;
  }

  p + p {
    margin-top: 1rem;
  }
}
</style>
